import { render, staticRenderFns } from "./FishHistory.vue?vue&type=template&id=7df2c628&scoped=true"
import script from "./FishHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FishHistory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FishHistory.vue?vue&type=style&index=0&id=7df2c628&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df2c628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df2c628')) {
      api.createRecord('7df2c628', component.options)
    } else {
      api.reload('7df2c628', component.options)
    }
    module.hot.accept("./FishHistory.vue?vue&type=template&id=7df2c628&scoped=true", function () {
      api.rerender('7df2c628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FishHistory.vue"
export default component.exports